// src/pages/SingleService.js

import React, { useEffect, useState } from 'react';
import { useParams, Link, Navigate } from 'react-router-dom';

import img1 from '../assets/1financial_management.png';
import img2 from '../assets/2financial_dvisory.png';
import img3 from '../assets/3transaction_advisory.png';
import img4 from '../assets/4capital raising.png';
import img5 from '../assets/5advanced_cashflow_management.png';
import img6 from '../assets/6growth_centric_financial_strategy.png';
import img7 from '../assets/7technology_integration.png';
import img8 from '../assets/8risk_management.png';
import img9 from '../assets/9accounting_bookkeeping.png';
import img10 from '../assets/10tax_advisory.png';

const serviceData = {
  'financial-management-services': {
    title: "Financial Management Services",
    overview: "Comprehensive financial oversight and reporting designed to align your daily financial operations with long-term strategic business goals. By providing accurate data and expert interpretation, we empower your leadership to make informed, proactive decisions that drive sustainable growth.",
    image: img1,
    subServices: [
      { title: "Financial Statement Preparation (Income Statement, Balance Sheet, Cash Flow)", desc: "Accurate and timely compilation of essential financial statements to provide a transparent view of your business's financial health." },
      { title: "Budgeting, Forecasting, & Variance Analysis", desc: "Strategic forward-looking models paired with detailed variance tracking to keep your financial targets on course." },
      { title: "Cash Flow Management & Short/Long-Term Projections", desc: "Proactive liquidity planning to ensure your business maintains the necessary capital to operate and expand." },
      { title: "Financial Modeling & Scenario Analysis", desc: "Dynamic mathematical models of your business to stress-test strategies and prepare for varying market conditions." },
      { title: "Key Performance Indicator (KPI) Tracking & Management Dashboards", desc: "Customized visual dashboards that deliver real-time insights into your most critical financial metrics." },
      { title: "Working Capital Optimization", desc: "Streamlining your current assets and liabilities to free up cash and maximize operational efficiency." },
      { title: "Enterprise Resource Planning (ERP) System Implementation Support", desc: "Expert guidance in selecting and deploying ERP solutions to unify and automate your financial data." }
    ]
  },
  'financial-advisory': {
    title: "Financial Advisory",
    overview: "Expert guidance on capital structuring, risk management, and strategic investments to drive profitability and operational efficiency. Our advisory team acts as your dedicated financial brain trust, navigating complex corporate challenges to build a resilient and highly profitable enterprise.",
    image: img2,
    subServices: [
      { title: "Corporate Growth Strategy & Strategic Planning", desc: "Aligning your financial capabilities with ambitious growth targets to ensure sustainable scaling." },
      { title: "Business Valuation & Pricing Analysis", desc: "Rigorous quantitative assessment of your company's worth and product pricing strategies to maximize market leverage." },
      { title: "Capital Structure Optimization", desc: "Balancing debt and equity to minimize your cost of capital and maximize shareholder value." },
      { title: "Debt Restructuring & Financing Advisory", desc: "Navigating distressed scenarios or expansion needs by renegotiating terms and securing optimal financing." },
      { title: "Profitability Analysis & Cost Reduction Strategy", desc: "Deep-dive diagnostics into margin erosion and implementation of targeted cost-saving initiatives." },
      { title: "Internal Controls Assessment & Implementation", desc: "Designing robust financial safeguards to prevent fraud, ensure compliance, and streamline audits." },
      { title: "Risk Management & Mitigation Strategy", desc: "Identifying exposure across operational and financial vectors and deploying proactive mitigation frameworks." }
    ]
  },
  'transaction-advisory-m-a': {
    title: "Transaction Advisory (M&A)",
    overview: "End-to-end support for mergers, acquisitions, and divestitures, including rigorous financial valuation and due diligence. We protect your interests throughout the deal lifecycle, ensuring hidden risks are exposed and synergies are accurately quantified for maximum transaction value.",
    image: img3,
    subServices: [
      { title: "Buy-Side & Sell-Side Mandates", desc: "Comprehensive representation and strategic guidance whether you are acquiring targets or seeking an exit." },
      { title: "Financial and Business Due Diligence", desc: "Exhaustive investigation into the target company's financial health, operations, and historical performance." },
      { title: "Quality of Earnings (QoE) Reporting", desc: "Normalized earnings analysis to reveal the true, sustainable cash flow generation of a business." },
      { title: "Mergers & Acquisitions (M&A) Strategy & Target Screening", desc: "Developing acquisition criteria and identifying high-value targets that align with your growth objectives." },
      { title: "Post-Merger Integration (PMI) Planning & Execution", desc: "Seamless consolidation of financial systems, teams, and processes to realize projected deal synergies." },
      { title: "Deal Structuring & Valuation Support", desc: "Designing optimal transaction terms and utilizing advanced valuation methodologies to negotiate from strength." },
      { title: "Virtual Data Room (VDR) Preparation & Management", desc: "Secure, highly organized curation of financial documents to facilitate smooth diligence phases." },
      { title: "Carve-out Financial Statements", desc: "Isolating the financials of a specific business unit being spun off or sold from the parent company." }
    ]
  },
  'capital-raising-investor-relations': {
    title: "Capital Raising & Investor Relations",
    overview: "Connecting your business with the right investors, managing fundraising cycles, and ensuring transparent ongoing communications. We translate complex financial metrics into compelling narratives that resonate with capital providers, securing the funding necessary for your next growth phase.",
    image: img4,
    subServices: [
      { title: "Preparing CIM, presentations and models to support fundraising rounds.", desc: "Crafting investor-ready Confidential Information Memorandums and pitch decks backed by rigorous financial models." },
      { title: "Managing investor relations, answering inquiries, and translating complex metrics for capital providers.", desc: "Acting as the primary financial liaison to maintain investor confidence and operational transparency." },
      { title: "Advising on equity and debt financing options and capital structure.", desc: "Evaluating the cost and dilutive impact of various funding avenues to select the optimal path." },
      { title: "Evaluating business feasibility to attract investors through tailored cost structures and pricing models.", desc: "Showcasing a highly scalable and profitable business model to maximize valuation and investor interest." }
    ]
  },
  'advanced-cash-flow-management': {
    title: "Advanced Cash Flow Management",
    overview: "Optimizing enterprise liquidity through predictive modeling, working capital adjustments, and stringent expense controls. We transform cash flow from a reactive tracking exercise into a strategic asset, ensuring you have the buffer required to weather volatility and fund aggressive expansion.",
    image: img5,
    subServices: [
      { title: "Building rolling 13-week cash flow models to proactively monitor liquidity.", desc: "Hyper-granular, short-term cash forecasting to ensure operational liabilities are always met." },
      { title: "Optimizing working capital, managing vendor relationships, and adjusting payment cycles.", desc: "Strategically timing receivables and payables to maximize cash-on-hand without straining partnerships." },
      { title: "Identifying early warning signs related to payroll risk or operational liquidity challenges.", desc: "Implementing predictive alerts to prevent cash crunches before they impact business continuity." },
      { title: "Establishing liquidity buffers to protect against market shifts and fund growth investments.", desc: "Creating strategic cash reserves that allow for opportunistic spending and crisis insulation." }
    ]
  },
  'growth-centric-financial-strategy-modeling': {
    title: "Growth-Centric Financial Strategy & Modeling",
    overview: "Building robust, dynamic financial models and projections to chart a clear, scalable path for organic and inorganic expansion. We provide the quantitative blueprint required for leadership to allocate resources effectively and pursue high-ROI market opportunities.",
    image: img6,
    subServices: [
      { title: "Developing top-down and bottom-up departmental budgets tailored for scaling.", desc: "Aligning high-level strategic goals with granular departmental spending limits." },
      { title: "Conducting forward-looking scenario analyses to model the impacts of rate changes, internal shifts, and market expansions.", desc: "Stress-testing your financial future against multiple internal and macroeconomic variables." },
      { title: "Implementing rolling forecasts that rely on real-time data instead of static annual budgets.", desc: "Replacing outdated annual budgets with agile, continuously updated financial projections." },
      { title: "Analyzing expenses, operational resources, and profitability margins to eliminate wastage.", desc: "Deep operational audits designed to lean out processes and boost bottom-line performance." },
      { title: "Creating customized improvement plans and go-to-market financial strategies to drive overall productivity.", desc: "Translating financial insights into actionable, step-by-step operational playbooks." }
    ]
  },
  'technology-integration-system-architecture': {
    title: "Technology Integration & System Architecture",
    overview: "Implementing and optimizing automated ERP workflows and modern financial tech stacks for maximum operational efficiency. We modernize your finance department, eliminating manual entry errors and providing real-time data visibility across your entire organizational structure.",
    image: img7,
    subServices: [
      { title: "Recommending and integrating advanced tools like ERP systems, FP&A platforms, and cloud-based billing.", desc: "Curating and deploying the exact software stack needed to automate your specific financial workflows." },
      { title: "Developing automated Business Intelligence (BI) dashboards to track real-time Key Performance Indicators (KPIs).", desc: "Transforming raw financial data into visually intuitive, actionable metrics for executive leadership." },
      { title: "Designing Standard Operating Procedures (SOPs) for rapid month-end closes and expense approvals.", desc: "Engineering frictionless internal processes that drastically reduce administrative overhead and closing times." },
      { title: "Guiding the company through digital transformation by defining the right software choices and reporting structures.", desc: "Serving as your technical-financial liaison to ensure IT implementations translate to business value." }
    ]
  },
  'risk-management-governance-restructuring': {
    title: "Risk Management, Governance, & Restructuring",
    overview: "Identifying structural vulnerabilities, ensuring regulatory compliance, and executing restructuring operations for resilient corporate health. We build the institutional safeguards required to protect your assets and guide you safely through periods of intense scaling or distress.",
    image: img8,
    subServices: [
      { title: "Designing and implementing robust internal controls and governance frameworks to support higher revenue milestones.", desc: "Establishing enterprise-grade oversight to prevent revenue leakage and ensure accountability." },
      { title: "Recognizing potential financial or operational risks and executing mitigation strategies.", desc: "Proactive threat detection spanning market risks, credit risks, and internal operational failures." },
      { title: "Preparing the business infrastructure for comprehensive audits, funding rounds, or eventual exits.", desc: "Ensuring your financials are bulletproof and strictly compliant to facilitate seamless external reviews." },
      { title: "Restructuring the organizational hierarchy and setting up in-house finance teams as the company scales.", desc: "Redesigning reporting lines and building out internal capabilities to match your evolving size." },
      { title: "Providing crisis management, turnaround support, and interim leadership during transitional periods.", desc: "Deploying experienced financial leadership to stabilize operations and engineer rapid recoveries." }
    ]
  },
  'accounting-bookkeeping-services': {
    title: "Accounting & Bookkeeping Services",
    overview: "Accurate, timely, and fully compliant financial record-keeping tailored specifically to complex, high-growth enterprise requirements. We manage the foundational elements of your finance department with precision, ensuring your books are always audit-ready.",
    image: img9,
    subServices: [
      { title: "Full-Cycle Bookkeeping", desc: "Comprehensive management of daily transactions, ensuring every financial event is accurately recorded." },
      { title: "Accounts Payable (A/P) & Accounts Receivable (A/R) Management", desc: "Optimizing cash conversion cycles by efficiently managing outgoing payments and accelerating collections." },
      { title: "Payroll Processing & Administration", desc: "Flawless execution of employee compensation, tax withholdings, and benefits administration." },
      { title: "Bank & Credit Card Reconciliation", desc: "Meticulous matching of internal records with banking statements to catch discrepancies instantly." },
      { title: "Month-End, Quarter-End, & Year-End Close Process", desc: "Accelerated and accurate closing procedures to deliver timely financial statements to stakeholders." },
      { title: "Fixed Asset Tracking & Depreciation Management", desc: "Rigorous accounting of capital expenditures and precise calculation of amortization and depreciation." },
      { title: "General Ledger Maintenance & Clean-up", desc: "Continuous auditing and reorganization of your chart of accounts to maintain pristine financial data." }
    ]
  },
  'tax-advisory-compliance': {
    title: "Tax Advisory & Compliance",
    overview: "Strategic global and domestic tax planning combined with strict regulatory compliance to minimize liabilities and maximize returns. Our experts navigate the complexities of evolving tax codes to ensure your business structure is optimized for maximum tax efficiency.",
    image: img10,
    subServices: [
      { title: "Corporate, Partnership, & Individual Tax Return Preparation", desc: "Accurate and timely filing of all necessary tax documents across multiple corporate structures." },
      { title: "Strategic Tax Planning & Liability Minimization", desc: "Forward-looking tax strategies designed to legally reduce your corporate tax burden and preserve cash." },
      { title: "State, Local, & Cross-Border Tax Advisory", desc: "Navigating complex multi-jurisdictional tax obligations for expanding and international enterprises." },
      { title: "Audit Representation & Tax Dispute Resolution", desc: "Expert defense and liaison services during tax authority audits or disputes." },
      { title: "Transfer Pricing Strategy & Documentation", desc: "Structuring intercompany transactions to comply with global regulations while optimizing tax outcomes." },
      { title: "Sales & Use Tax Compliance", desc: "Automated tracking, calculation, and remittance of indirect taxes across varying tax jurisdictions." },
      { title: "Regulatory Compliance Reporting", desc: "Ensuring adherence to all specialized financial and industry-specific tax reporting requirements." }
    ]
  }
};

const topCountries = [
  "India", "United States", "United Kingdom", "United Arab Emirates", 
  "Singapore", "Australia", "Canada", "Germany", "Other"
];

function SingleService() {
  const { id } = useParams();
  const service = serviceData[id];

  const [formData, setFormData] = useState({
    companyName: '',
    country: '',
    email: '',
    phone: '',
    interest: ''
  });
  
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [id]);

  if (!service) {
    return <Navigate to="/services" replace />;
  }

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);

    const payload = {
      access_key: "de271c99-03f3-4ee1-bb87-140545d6ddbe", // Replace with your Web3Forms Access Key
      subject: `New Consultation Request: ${service.title} - ${formData.companyName}`,
      from_name: formData.companyName,
      ...formData
    };

    try {
      const response = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(payload)
      });

      const result = await response.json();

      if (result.success) {
        setSubmitStatus('success');
        setFormData({
          companyName: '', country: '', email: '', phone: '', interest: ''
        });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      console.error("Form submission error:", error);
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
      setTimeout(() => setSubmitStatus(null), 5000);
    }
  };

  return (
    <div style={{ fontFamily: 'Arial, sans-serif', color: '#333' }}>
      
      {/* 1. Overview Section */}
      <section style={styles.overviewSection}>
        <div style={styles.overviewContainer}>
          <div style={styles.overviewTextContainer}>
            <h1 style={styles.overviewTitle}>{service.title}</h1>
            <div style={styles.titleUnderline}></div>
            <p style={styles.overviewDesc}>{service.overview}</p>
          </div>
          <div style={styles.overviewImageContainer}>
            <img 
              src={service.image} 
              alt={service.title} 
              style={styles.overviewImage} 
            />
          </div>
        </div>
      </section>

      {/* 2. Sub-services and Form Section */}
      <section style={styles.contentSection}>
        <div style={styles.contentContainer}>
          
          {/* Left Column: Sub-Services */}
          <div style={styles.subServicesColumn}>
            <h2 style={styles.subServicesHeader}>Specific Offerings</h2>
            <div style={styles.subServicesList}>
              {service.subServices.map((sub, index) => (
                <div key={index} style={styles.subServiceCard}>
                  <div style={styles.subServiceIcon}>&#10003;</div>
                  <div style={styles.subServiceText}>
                    <h4 style={styles.subServiceTitle}>{sub.title}</h4>
                    <p style={styles.subServiceDesc}>{sub.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Right Column: Contact Form */}
          <div style={styles.formColumn}>
            <div style={styles.formCard}>
              <h3 style={styles.formTitle}>Request Consultation</h3>
              <p style={styles.formSubtitle}>Connect with our experts regarding {service.title}.</p>
              
              <form onSubmit={handleSubmit} style={styles.form}>
                <div style={styles.inputGroup}>
                  <label style={styles.label}>Company name*</label>
                  <input 
                    type="text" 
                    name="companyName"
                    required 
                    value={formData.companyName}
                    onChange={handleChange}
                    style={styles.input} 
                    placeholder="Enter your company name" 
                  />
                </div>
                
                <div style={styles.inputGroup}>
                  <label style={styles.label}>Country*</label>
                  <select 
                    name="country"
                    required 
                    value={formData.country}
                    onChange={handleChange}
                    style={styles.select}
                  >
                    <option value="">Select Country...</option>
                    {topCountries.map((c, idx) => (
                      <option key={idx} value={c}>{c}</option>
                    ))}
                  </select>
                </div>
                
                <div style={styles.inputGroup}>
                  <label style={styles.label}>Email-id*</label>
                  <input 
                    type="email" 
                    name="email"
                    required 
                    value={formData.email}
                    onChange={handleChange}
                    style={styles.input} 
                    placeholder="work@company.com" 
                  />
                </div>
                
                <div style={styles.inputGroup}>
                  <label style={styles.label}>Phone #</label>
                  <input 
                    type="tel" 
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    style={styles.input} 
                    placeholder="+1 (555) 000-0000" 
                  />
                </div>
                
                <div style={styles.inputGroup}>
                  <label style={styles.label}>Specific interest</label>
                  <select 
                    name="interest"
                    value={formData.interest}
                    onChange={handleChange}
                    style={styles.select}
                  >
                    <option value="">Select an area of interest...</option>
                    {service.subServices.map((sub, idx) => (
                      <option key={idx} value={sub.title}>{sub.title}</option>
                    ))}
                    <option value="General Inquiry">General Inquiry</option>
                  </select>
                </div>

                {submitStatus === 'success' && (
                  <div style={styles.successMessage}>
                    ✓ Thank you! Your request has been sent successfully.
                  </div>
                )}

                {submitStatus === 'error' && (
                  <div style={styles.errorMessage}>
                    ⚠ There was an error sending your request. Please try again.
                  </div>
                )}
                
                <button type="submit" style={styles.submitBtn} disabled={isSubmitting}>
                  {isSubmitting ? 'Submitting...' : 'Submit Request'}
                </button>
              </form>
            </div>
          </div>

        </div>
      </section>

      {/* Breadcrumb / Back Link */}
      <section style={styles.backSection}>
        <Link to="/services" style={styles.backLink}>&larr; Back to All Services</Link>
      </section>

    </div>
  );
}

const styles = {
  overviewSection: { 
    padding: '60px 5%', 
    backgroundColor: '#FFFFFF',
    borderBottom: '1px solid #E5E7EB'
  },
  overviewContainer: {
    maxWidth: '1200px',
    margin: '0 auto',
    display: 'flex', 
    flexWrap: 'wrap', 
    alignItems: 'center', 
    gap: '50px',
  },
  overviewTextContainer: { 
    flex: 1, 
    minWidth: '300px' 
  },
  overviewTitle: { 
    fontSize: '42px', 
    color: '#002B49', 
    marginBottom: '15px', 
    fontWeight: 'bold',
    lineHeight: '1.2'
  },
  titleUnderline: {
    height: '5px',
    width: '80px',
    backgroundColor: '#E1261C',
    marginBottom: '25px',
    borderRadius: '2px'
  },
  overviewDesc: { 
    fontSize: '18px', 
    lineHeight: '1.7', 
    color: '#4B5563',
    margin: 0,
    textAlign: 'justify'
  },
  overviewImageContainer: { 
    flex: 1, 
    minWidth: '300px',
    display: 'flex',
    justifyContent: 'center'
  },
  overviewImage: { 
    width: '100%', 
    height: 'auto',
    maxHeight: '400px', 
    objectFit: 'cover',
    borderRadius: '16px', 
    boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)'
  },

  contentSection: {
    padding: '60px 5% 80px',
    backgroundColor: '#F9FAFB'
  },
  contentContainer: {
    maxWidth: '1200px',
    margin: '0 auto',
    display: 'flex',
    flexWrap: 'wrap',
    gap: '50px',
    alignItems: 'flex-start'
  },
  
  subServicesColumn: {
    flex: '2',
    minWidth: '300px'
  },
  subServicesHeader: {
    fontSize: '32px',
    color: '#002B49',
    marginBottom: '30px',
    fontWeight: 'bold'
  },
  subServicesList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px'
  },
  subServiceCard: {
    backgroundColor: '#FFFFFF',
    padding: '25px',
    borderRadius: '12px',
    border: '1px solid #E5E7EB',
    borderLeft: '5px solid #002B49',
    display: 'flex',
    gap: '20px',
    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05)',
    transition: 'transform 0.2s ease, box-shadow 0.2s ease',
  },
  subServiceIcon: {
    color: '#E1261C',
    fontSize: '24px',
    fontWeight: 'bold',
    marginTop: '2px'
  },
  subServiceText: {
    flex: 1
  },
  subServiceTitle: {
    fontSize: '20px',
    color: '#111827',
    marginBottom: '10px',
    fontWeight: 'bold',
    lineHeight: '1.4'
  },
  subServiceDesc: {
    fontSize: '16px',
    color: '#4B5563',
    lineHeight: '1.6',
    margin: 0
  },

  formColumn: {
    flex: '1',
    minWidth: '320px',
    position: 'sticky',
    top: '100px'
  },
  formCard: {
    backgroundColor: '#FFFFFF',
    padding: '35px 30px',
    borderRadius: '16px',
    border: '1px solid #E5E7EB',
    boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.1)',
  },
  formTitle: {
    fontSize: '24px',
    color: '#002B49',
    marginBottom: '10px',
    fontWeight: 'bold'
  },
  formSubtitle: {
    fontSize: '15px',
    color: '#6B7280',
    marginBottom: '25px',
    lineHeight: '1.5'
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '15px'
  },
  inputGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: '6px'
  },
  label: {
    fontSize: '14px',
    fontWeight: '600',
    color: '#374151'
  },
  input: {
    padding: '12px 15px',
    borderRadius: '8px',
    border: '1px solid #D1D5DB',
    fontSize: '15px',
    fontFamily: 'inherit',
    outline: 'none',
    transition: 'border-color 0.2s ease',
    backgroundColor: '#F9FAFB',
  },
  select: {
    padding: '12px 15px',
    borderRadius: '8px',
    border: '1px solid #D1D5DB',
    fontSize: '15px',
    fontFamily: 'inherit',
    outline: 'none',
    backgroundColor: '#F9FAFB',
    transition: 'border-color 0.2s ease'
  },
  submitBtn: {
    marginTop: '10px',
    backgroundColor: '#E1261C',
    color: '#FFFFFF',
    border: 'none',
    padding: '15px',
    borderRadius: '8px',
    fontSize: '16px',
    fontWeight: 'bold',
    cursor: 'pointer',
    transition: 'background-color 0.2s ease'
  },
  successMessage: {
    backgroundColor: '#DEF7EC',
    color: '#03543F',
    padding: '12px',
    borderRadius: '6px',
    fontSize: '14px',
    fontWeight: '600'
  },
  errorMessage: {
    backgroundColor: '#FDE8E8',
    color: '#9B1C1C',
    padding: '12px',
    borderRadius: '6px',
    fontSize: '14px',
    fontWeight: '600'
  },

  backSection: {
    padding: '0 5% 60px',
    backgroundColor: '#F9FAFB',
    maxWidth: '1200px',
    margin: '0 auto'
  },
  backLink: {
    color: '#002B49',
    textDecoration: 'none',
    fontWeight: 'bold',
    fontSize: '16px',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '5px'
  }
};

export default SingleService;